import { lazy } from "react";
import { MODULE_IDS } from "../../../constants/enums";
import Loadable from "../../../layout/fullLayout/loadable/loadable";
import { AuthorizedRoute } from "../../../router/AuthorizedRoute";
import { app_navbar_routes } from "../../../constants/app-navbar-routes";

const VendorPaymentTableView = Loadable(
  lazy(() =>
    import("./VendorPaymentTableView").then(({ VendorPaymentTableView }) => ({
      default: VendorPaymentTableView,
    })),
  ),
);

const SingleVendorPaymentForm = Loadable(
  lazy(() =>
    import("./SingleVendorPaymentForm").then(({ SingleVendorPaymentForm }) => ({
      default: SingleVendorPaymentForm,
    })),
  ),
);

export const vendorPaymentsRoutes = [
  {
    path: app_navbar_routes.app.expense.vendor_payments,
    exact: true,
    element: (
      <AuthorizedRoute moduleIds={[MODULE_IDS.EXPENSE]}>
        <VendorPaymentTableView />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${app_navbar_routes.app.expense.vendor_payments}/create`,
    exact: true,
    element: (
      <AuthorizedRoute moduleIds={[MODULE_IDS.EXPENSE]}>
        <SingleVendorPaymentForm />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${app_navbar_routes.app.expense.vendor_payments}/edit/:uuid`,
    exact: true,
    element: (
      <AuthorizedRoute moduleIds={[MODULE_IDS.EXPENSE]}>
        <SingleVendorPaymentForm />
      </AuthorizedRoute>
    ),
  },
];
